import { useCallback, useMemo } from "react";
import type { DataSnapshot } from "firebase/database";
import {
    RecordBank,
    RecordDeb,
    RecordER,
    RecordERAnzahlung,
    RecordFE,
    RecordKB,
    RecordLA,
    RecordPOS,
} from "@domain/models/GenericRecord";
import { readFirebaseRecord } from "@domain/models/converters/firebaseReaders";

export const useRecordsInitializers = () => {
    const erInit = useCallback((snap: DataSnapshot) => new RecordER(readFirebaseRecord(snap.val())), []);
    const erAInit = useCallback((snap: DataSnapshot) => new RecordERAnzahlung(readFirebaseRecord(snap.val())), []);
    const feInit = useCallback((snap: DataSnapshot) => new RecordFE(readFirebaseRecord(snap.val())), []);
    const posInit = useCallback((snap: DataSnapshot) => new RecordPOS(readFirebaseRecord(snap.val())), []);
    const laInit = useCallback((snap: DataSnapshot) => new RecordLA(readFirebaseRecord(snap.val())), []);
    const debInit = useCallback((snap: DataSnapshot) => new RecordDeb(readFirebaseRecord(snap.val())), []);

    const bankInit = useCallback((snap: DataSnapshot) => new RecordBank(readFirebaseRecord(snap.val())), []);
    const kbInit = useCallback((snap: DataSnapshot) => {
        const record = readFirebaseRecord(snap.val());
        record.priority = snap.priority as number;
        return new RecordKB(record);
    }, []);

    return useMemo(() => {
        return {
            erInit,
            erAInit,
            feInit,
            posInit,
            laInit,
            debInit,
            bankInit,
            kbInit,
        };
    }, [erInit, erAInit, feInit, posInit, laInit, debInit, bankInit, kbInit]);
};
